import { LogLayer, LogLevel } from 'loglayer';

import { AppLogger, LogFunction, Runtime } from './types';
import { getCurrentRuntimeEnvironment } from './utils/getEnvironment';
import { logWithMetadata } from './utils/logWithMeta';

const currentRuntimeEnvironment = getCurrentRuntimeEnvironment();

const currentLoggerInstance: Promise<LogLayer> =
	currentRuntimeEnvironment === Runtime.Server
		? import('./environments/logger.server').then((module) => module.serverLoggerInstance)
		: import('./environments/logger.client').then((module) => module.clientLoggerInstance);

const logFunction =
	(level: LogLevel): LogFunction =>
	async (message, meta) =>
		logWithMetadata(await currentLoggerInstance, level, message, meta);

export const logger: AppLogger = {
	info: logFunction(LogLevel.info),
	warn: logFunction(LogLevel.warn),
	error: logFunction(LogLevel.error),
	debug: logFunction(LogLevel.debug),
	trace: logFunction(LogLevel.trace),
	fatal: logFunction(LogLevel.fatal),
};
